import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { imagesByYear } from "../data/imagesByYear";
import {  FaTimes } from "react-icons/fa";
import { FaMagnifyingGlass } from "react-icons/fa6";
import PageWrapper from "../components/PageWrapper";

const YearGallery = () => {
  const { year } = useParams();
  const data = imagesByYear[year];
  const sections = data?.sections || [];

  const [selectedImage, setSelectedImage] = useState(null);

  const handleBackdropClick = (e) => {
    // Only close if the backdrop itself was clicked
    if (e.target.id === "modal-backdrop") {
      setSelectedImage(null);
    }
  };

  return (
    <PageWrapper>
      <div className="bg-gradient-to-b from-sky-100 via-white to-white py-12 sm:py-16 min-h-screen">
        <div className="mx-auto max-w-6xl px-2 sm:px-6 lg:px-4">
          <h2 className="text-left text-base font-semibold text-sky-600 font-heading">
            {data?.title || "Fotogalerie"}
          </h2>
          <h3 className="mt-2 max-w-lg text-left text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl font-heading">
            {data?.subtitle || year}
          </h3>

          {sections.map((section, idx) => (
            <div key={idx} className="mt-12">
              <h4 className="text-lg font-semibold text-sky-600 mb-6 font-heading">
                {section.subtitle}
              </h4>
              <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-3 gap-6 space-y-6">
                {section.images.map((src, i) => (
                  <div key={i} className="relative group break-inside-avoid">
                    <img
                      src={src}
                      alt={`${section.subtitle} - Bild ${i + 1}`}
                      className="w-full h-auto object-contain rounded-2xl shadow-sm"
                    />
                    <button
                      onClick={() => setSelectedImage(src)}
                      className="absolute bottom-2 right-2 p-1 bg-white/80 rounded-full text-gray-700 hover:text-black hover:scale-105 transition font-body"
                    >
                      <FaMagnifyingGlass size={8} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {sections.length === 0 && (
            <p className="mt-6 text-gray-500 font-body">Keine Bilder für {year} gefunden.</p>
          )}
        </div>

        {/* Modal View */}
        {selectedImage && (
          <div
            id="modal-backdrop"
            className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
            onClick={handleBackdropClick}
          >
            <div className="relative max-w-3xl w-full px-4">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 text-white bg-black/70 p-2 rounded-full hover:bg-black font-body"
              >
                <FaTimes size={12} />
              </button>
              <img
                src={selectedImage}
                alt="Vorschau"
                className="w-full h-auto max-h-[80vh] rounded-xl object-contain"
              />
            </div>
          </div>
        )}
      </div>
    </PageWrapper>
  );
};

export default YearGallery;
